"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiInlineOptions = exports.ViewToggle = exports.SingleInlineOptions = exports.Option = void 0;
const React = require("react");
const _ = require("lodash");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles, "inlineOptions");
const InlineOptions = ({ children, className = "" }) => React.createElement("div", { className: css("", { className }) }, children);
exports.default = InlineOptions;
class Option extends React.Component {
    render() {
        const name = _.uniqueId("_inlineInput");
        const { selected, disabled, children, onClick, width, className } = this.props;
        const divWidth = {
            width: width || null
        };
        return (React.createElement("div", { onClick: disabled ? undefined : onClick, id: name, style: width ? divWidth : null, className: css("option", {
                selected,
                disabled,
                className
            }), "data-test": "option", "data-test-selected": selected ? "true" : "false" },
            React.createElement("span", null, children)));
    }
}
exports.Option = Option;
const SingleInlineOptions = ({ onSelection, options = [], optionCaptions, selected = null, optionWidth, className }) => {
    return (React.createElement(InlineOptions, { className: className }, options.map((o, i) => (React.createElement(Option, { width: optionWidth, key: o, selected: o === selected, onClick: () => onSelection(o), className: `${className}_option` },
        React.createElement("div", null,
            o,
            Array.isArray(optionCaptions) && i < optionCaptions.length && (React.createElement("div", { className: `${className}_option_caption` }, optionCaptions[i]))))))));
};
exports.SingleInlineOptions = SingleInlineOptions;
const ViewToggle = ({ onSelection, options = [], selected = null }) => {
    return (React.createElement(InlineOptions, { className: css("-alt") }, options.map(o => (React.createElement(Option, { width: "150px", key: o, selected: o === selected, onClick: () => onSelection(o) }, o)))));
};
exports.ViewToggle = ViewToggle;
const MultiInlineOptions = ({ onSelection, options = [], selected = [], disabled, allowMultiple = true }) => {
    return (React.createElement(InlineOptions, null, options.map(o => (React.createElement(Option, { key: o, selected: selected.indexOf(o) > -1, onClick: () => onSelection(_.xor(selected, [o])), disabled: disabled, allowMultiple: allowMultiple }, o)))));
};
exports.MultiInlineOptions = MultiInlineOptions;
//# sourceMappingURL=index.js.map